import React from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

export default function Footer({ className = "" }) {
  return (
    <footer className={`py-24 px-6 border-t border-white/5 text-center ${className}`}>
      <div className="flex flex-col items-center gap-8">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-[#F9D965] rounded-full flex items-center justify-center text-[#24574E]">
            <Star size={16} fill="currentColor" />
          </div>
          <span className="text-xl font-bold tracking-tight uppercase text-white">SuperAsso</span>
          <span className="px-1.5 py-0.5 text-[10px] font-bold tracking-widest uppercase border border-white/20 rounded text-white/40">
            Beta
          </span>
        </div>
        <div className="flex flex-wrap justify-center gap-10 font-bold text-xs uppercase tracking-widest text-[#F5F3EE]/40">
          <Link to="/confidentialite" className="hover:text-[#F9D965] transition-colors">Confidentialité</Link>
          <Link to="/legal" className="hover:text-[#F9D965] transition-colors">Mentions Légales</Link>
          <Link to="/cgu" className="hover:text-[#F9D965] transition-colors">CGU/CGV</Link>
          <Link to="/faq" className="hover:text-[#F9D965] transition-colors">FAQ</Link>
          <Link to="/contact" className="hover:text-[#F9D965] transition-colors">Contact</Link>
        </div>
        <p className="text-[10px] font-black text-white/10 uppercase tracking-[0.3em]">
          © {new Date().getFullYear()} SuperAsso <span className="text-[8px] opacity-40 px-1 border border-white/10 rounded ml-1">BETA</span> — Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}
